import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { generateValidation } from 'ecs-react-components/dist/index.es';
import Header from '../../components/Header/Header';
import { messages } from './AccountSettings.i18n';
import ChangeEmail from './ChangeEmail/ChangeEmail';
import ChangePassword from './ChangePassword/ChangePassword';
import PatientInformation from './PatientInformation/PatientInformation';
import PatientNotificationSettings from './PatientNotificationSettings';
import { getValidations } from './ChangePassword/ChangePassword.validation';
import { loadPasswordRules } from '../../redux/modules/signup/create-account/create-account-middleware';
import { updatePasswordRequestById } from '../../redux/modules/auth/auth-middleware';
import * as MsgBarActions from '../../redux/modules/system-shared/message-bar-action-creator';

class AccountSettings extends Component {
  UNSAFE_componentWillMount = () => {
    this.props.dispatch(loadPasswordRules());
  }

  onFormChange = () => {
    this.props.dispatch(MsgBarActions.dismissMessage());
  };

  sendUpdatePasswordRequest = (creds) => {
    this.props.dispatch(updatePasswordRequestById(creds.userId, creds.oldPwd, creds.newPwd,
      creds.confirmNewPwd, 'changepasswordform'));
  }

  renderChangePassword = () => {
    if (!this.props.loginType || this.props.loginType.toLowerCase() !== 'singlesignon') {
      return (<ChangePassword {
            ...generateValidation(getValidations(this.props.pwdRules))
            }
        onFormChange={this.onFormChange}
        sendUpdatePasswordRequest={this.sendUpdatePasswordRequest}
      />);
    }
    return null;
  }

  render() {
    return (
      <div data-qa-item="account-settings-container">
        <Header headerTitle={ <FormattedMessage { ...messages.header } /> } />
        <ChangeEmail onFormChange={this.onFormChange} />
        {this.renderChangePassword()}
        <PatientNotificationSettings onFormChange={this.onFormChange} />
        <PatientInformation />
      </div>
    );
  }
}

AccountSettings.propTypes = {
  dispatch: PropTypes.func,
  minLength: PropTypes.number,
  capitalLetters: PropTypes.number,
  numbers: PropTypes.number,
  specialCharacters: PropTypes.number,
  loginType: PropTypes.string,
  pwdRules: PropTypes.object,
};

const mapStateToProps = (state) => ({
  pwdRules: state.signUp.password,
  loginType: state.profile.auth.loginType,
});

export default connect(mapStateToProps)(AccountSettings);